import { ENV } from '@/constants';
import { exploreSchemaItemList } from '../exploreSchema';

export const schemaObject_AiDollGenerator = {
	'@context': 'https://schema.org',
	'@graph': [
		{
			'@type': 'WebPage',
			'@id': 'https://liftapp.ai/ai-doll-generator',
			name: 'AI Doll Generator – Create Custom AI Dolls | Lift',
			description:
				"Try AI Doll transformation with Lift's AI generator. Upload a photo and turn yourself into a custom Doll. No design skills needed.",
			url: 'https://liftapp.ai/ai-doll-generator',
			image: 'https://liftapp.ai/seo-image.webp',
			mainEntity: [
				{ '@id': 'https://liftapp.ai/ai-doll-generator#product' },
				{ '@id': 'https://liftapp.ai/ai-doll-generator#howto' },
				{ '@id': 'https://liftapp.ai/ai-doll-generator#benefits' },
				{ '@id': 'https://liftapp.ai/ai-doll-generator#faq' },
				{ '@id': 'https://liftapp.ai/ai-doll-generator#why-lift' },
				{ '@id': 'https://liftapp.ai/ai-doll-generator#explore-tools' },
				{ '@id': 'https://liftapp.ai/ai-doll-generator#all-in-one' },
			],
		},
		// product
		{
			'@type': 'Product',
			'@id': 'https://liftapp.ai/ai-doll-generator#product',
			name: 'AI Doll Generator Online',
			description:
				"Transform your photos into stunning AI doll art with Lift's AI generator. No design skills needed.",
			url: 'https://liftapp.ai/ai-doll-generator',
			fileFormat: ['image/jpeg', 'image/png', 'image/webp'],
			memoryRequirements: 'Max file size: 20MB',
			brand: {
				'@type': 'Brand',
				name: 'Lift',
			},
			aggregateRating: {
				'@type': 'AggregateRating',
				ratingValue: '4.8',
				reviewCount: 130000,
				bestRating: '5',
				worstRating: '1',
			},
			interactionStatistic: [
				{
					'@type': 'InteractionCounter',
					interactionType: { '@type': 'InstallAction' },
					userInteractionCount: 13000000,
				},
			],
		},
		// howto
		{
			'@type': 'HowTo',
			'@id': 'https://liftapp.ai/ai-doll-generator#howto',
			name: 'How it works',
			step: [
				{
					'@type': 'HowToStep',
					position: 1,
					name: 'Upload your photos',
					text: "Choose a photo from your device or take one using Lift's app",
				},
				{
					'@type': 'HowToStep',
					position: 2,
					name: 'AI creates your custom doll',
					text: 'Our advanced AI analyzes your features and transforms them into a polished doll character with perfect styling, makeup, and aesthetic details',
				},
				{
					'@type': 'HowToStep',
					position: 3,
					name: 'Customize adjustments',
					text: 'Fine-tune your image with easy-to-use editing tools',
				},
				{
					'@type': 'HowToStep',
					position: 4,
					name: 'Download and use',
					text: 'Download your image or publish it straight to your social feeds',
				},
			],
		},
		// benefit
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/ai-doll-generator#benefits',
			name: 'Who can benefit from AI Doll Generator?',
			description:
				"Lift's AI Doll Generator is useful for social media users, content creators, artists, designers, friends, groups, brands, and marketers.",
			itemListOrder: 'Unordered',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'Social media users can join the viral AI doll trend with eye-catching transformations',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'Content creators can generate unique doll-style avatars and profile pictures',
				},
				{
					'@type': 'ListItem',
					position: 3,
					name: 'Artists and designers can explore custom doll aesthetics for characters and concepts',
				},
				{
					'@type': 'ListItem',
					position: 4,
					name: 'Friends and groups can make matching doll-style characters for group chats or events',
				},
				{
					'@type': 'ListItem',
					position: 5,
					name: 'Brands and marketers can create playful, shareable promotional content that stands out',
				},
			],
			image: {
				'@type': 'ImageObject',
				contentUrl:
					'https://liftapp.ai/_next/static/media/benefits.3da6de53.webp',
				name: 'AI Doll Generator Benefits',
				description: 'People enjoying AI doll transformations',
			},
		},

		// faq
		{
			'@type': 'FAQPage',
			'@id': 'https://liftapp.ai/ai-doll-generator#faq',
			mainEntity: [
				{
					'@type': 'Question',
					name: 'What is Lift AI Doll Generator?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Lift AI Doll Generator is a online tool that transforms your photos into AI doll art — including Barbie or Bratz-style dolls, custom avatars, and trendy doll transformations perfect for social media, profile pictures, or creative projects.',
					},
				},
				{
					'@type': 'Question',
					name: 'How does Lift AI Doll Generator work?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: "Our AI analyzes your photo's facial features and styling, then reimagines you as a polished doll character with smooth skin, enhanced features, stylized hair, and artistic details. The transformation is automatic and instant — no manual editing or design skills required.",
					},
				},
				{
					'@type': 'Question',
					name: 'Can I create AI dolls with any photo?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: "Yes. Lift works with any portrait photo — whether it's a selfie, a professional shot, or a casual picture. The AI adapts to your unique features to create doll transformations inspired by modern doll trends and distinctive avatar designs.",
					},
				},
				{
					'@type': 'Question',
					name: 'Can I download the results without a watermark?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: "Absolutely. All images generated or edited in Lift can be exported without watermark when you're on the Pro plan. Download them in high-res PNG or JPG — ready for social media, print, ads, or e-commerce.",
					},
				},
			],
		},

		// why lift
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/ai-doll-generator#why-lift',
			name: "Why Lift's AI Doll Generator stands out",
			description:
				"Lift's AI Doll Generator combines professional-grade AI, ease of use, and affordability — making it a trusted choice for millions of users worldwide.",
			itemListOrder: 'Unordered',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'High-quality results',
					description:
						'AI-powered technology delivers professional-grade visuals every time',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'Intelligent rendering',
					description:
						'AI tailors the effect to the scene and subject for optimal results',
				},
				{
					'@type': 'ListItem',
					position: 3,
					name: 'Cross-platform support',
					description: 'Available on iOS, Android, and Web for seamless access',
				},
				{
					'@type': 'ListItem',
					position: 4,
					name: 'Budget-friendly',
					description:
						'Save on costly designers with an affordable and intuitive tool',
				},
			],
			image: {
				'@type': 'ImageObject',
				contentUrl:
					'https://liftapp.ai/_next/static/media/whyUse.ae83a89c.webp',
				name: 'Why Choose AI Doll Generator',
				description: 'AI Doll Generator advantages',
			},
		},
		// explore
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/ai-doll-generator#explore-tools',
			name: 'Explore the AI tools',
			description:
				'A curated list of AI-powered tools for image generation, enhancement, background removal, and more – all available on Lift.',
			itemListOrder: 'Unordered',
			...exploreSchemaItemList,
		},

		{
			'@type': 'SoftwareApplication',
			'@id': 'https://liftapp.ai/ai-doll-generator#all-in-one',
			name: 'Try Lift – AI Content Creation Tools',
			description:
				'Your all-in-one tools to create, edit, and elevate your content. Create stunning content with AI tools, templates, and editing features effortlessly.',
			operatingSystem: 'iOS, Android, Web',
			applicationCategory: 'MultimediaApplication',
			url: `${ENV.LIFT_WEB_APP_URL}/sign-in?auto_login=true`,
			applicationSubCategory: 'Content Creation',
			publisher: {
				'@type': 'Organization',
				name: 'Lift',
				url: 'https://liftapp.ai',
			},
			potentialAction: [
				{
					'@type': 'ViewAction',
					name: 'Open Web App',
					target: `${ENV.LIFT_WEB_APP_URL}/sign-in?auto_login=true`,
				},
			],
		},

		{
			'@type': 'BreadcrumbList',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'Home',
					item: 'https://liftapp.ai',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'AI Doll Generator',
					item: 'https://liftapp.ai/ai-doll-generator',
				},
			],
		},
	],
};
